import { createAsyncThunk } from '@reduxjs/toolkit';
import eventStatusService from './EventStatus.service';
import { EventStatusResultFetch } from './EventStatus.type';

export const getEventStatusListThunk = createAsyncThunk(
  'eventStatus/getEventStatusListThunk',
  async (
    { eventId, ids, search, page, orderOffset }: EventStatusResultFetch,
    thunkAPI,
  ) => {
    const { data } = await eventStatusService.getList(eventId, {
      search,
      page,
      filter: {
        ids,
        offset_order: orderOffset,
      },
    });

    return data;
  },
);
